





























































import Vue from 'vue';
import {
  Component, Inject,
} from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import {
  Alert,
  NoticeClass,
  Dialog,
} from '@kasasa/fbase-components/lib';
import { KCardHeader } from '@kasasa/fbase-components';
import { MacroResource, Macro } from '@/api/macro';

@Component({
  components: {
    KCardHeader,
  },
})
export default class MacrosView extends Vue {
  @Inject('MacroResource')
  macroResource!: MacroResource;

  search: string = '';

  macros: Macro[] = [];

  loading: boolean = false;

  deleting: boolean = false;

  headerItems: any = [
    {
      text: 'RegGen',
      disabled: false,
      link: false,
    },
    {
      text: 'Macros',
      disabled: true,
    },
  ];

    tableHeaders: DataTableHeader[] = [
      {
        text: '', value: 'edit', align: 'start', sortable: false,
      },
      {
        text: 'Name', value: 'name', align: 'start', sortable: true,
      },
      {
        text: 'Description', value: 'description', align: 'start', sortable: true,
      },
      {
        text: 'Is Root?', value: 'isRoot', align: 'start', sortable: true,
      },
      {
        text: '', value: '', align: 'start', sortable: false,
      },
    ];


    mounted() {
      this.loading = true;
      this.macroResource.getAll().then((macros:Macro[]) => {
        this.macros = macros;
      }).catch((error:any) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.loading = false;
      });
    }

    onDeleteMacro(name: string) {
      const dialog = new Dialog('Confirm Deletion', `Are you sure you want to delete "${name}"?`);
	      dialog.setAcceptLabel('OK')
	        .setDeclineLabel('Cancel');
	      this.$store.dispatch('notices/add', dialog).then((ok) => {
	        if (ok === 'accept') {
          this.deleteMacro(name);
        }
      });
    }

    deleteMacro(name: string) {
      this.deleting = true;
      this.macroResource.delete(name).then((deletedMacro:Macro) => {
        for (let i = 0; i < this.macros.length; i++) {
          if (this.macros[i].name === name) {
            this.macros.splice(i, 1);
            break;
          }
        }
      }).catch((error:any) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.deleting = false;
      });
    }

    showErrorMessage(error: any) {
      console.error(error);
      const al = new Alert(error, NoticeClass.ERROR);
      al.setTimeout(5000);
      this.$store.dispatch('notices/add', al);
    }
}
